unit UZrValueModel;

interface

uses
  Js;

type
  TZrValueModel = class
  private
    FZeitpunkt2: TDateTime;
    FBemerkung: string;
    FZeitpunkt1: TDateTime;
    FId: Integer;
    FKst: string;
    FValue: string;
    FBS2: string;
    FDatum: TDateTime;
    FBS1: string;
    FZeitart: string;
    procedure ClearValues;
    procedure SetValues(Json: string); overload;
    procedure SetValues(Obj: TJsObject); overload;
    procedure SetBemerkung(const Value: string);
    procedure SetBS1(const Value: string);
    procedure SetBS2(const Value: string);
    procedure SetDatum(const Value: TDateTime);
    procedure SetId(const Value: Integer);
    procedure SetKst(const Value: string);
    procedure SetValue(const Value: string);
    procedure SetZeitart(const Value: string);
    procedure SetZeitpunkt1(const Value: TDateTime);
    procedure SetZeitpunkt2(const Value: TDateTime);
  public
    constructor Create; overload;
    constructor Create(Json: string); overload;
    function ToString: string; override;
    property Id: Integer read FId write SetId;
    property Datum: TDateTime read FDatum write SetDatum;
    property Zeitart: string read FZeitart write SetZeitart;
    property BS1: string read FBS1 write SetBS1;
    property Zeitpunkt1: TDateTime read FZeitpunkt1 write SetZeitpunkt1;
    property BS2: string read FBS2 write SetBS2;
    property Zeitpunkt2: TDateTime read FZeitpunkt2 write SetZeitpunkt2;
    property Value: string read FValue write SetValue;
    property Kst: string read FKst write SetKst;
    property Bemerkung: string read FBemerkung write SetBemerkung;
  end;

implementation

uses
  System.SysUtils;

{ TZrValueModel }

procedure TZrValueModel.ClearValues;
begin
  Self.Id := 0;
  Self.Datum := 0;
  Self.Zeitart := '';
  Self.BS1 := '';
  Self.Zeitpunkt1 := 0;
  Self.BS2 := '';
  Self.Zeitpunkt2 := 0;
  Self.Value := '';
  Self.Kst := '';
  Self.Bemerkung := '';
end;

constructor TZrValueModel.Create;
begin
  Self.ClearValues;
end;

constructor TZrValueModel.Create(Json: string);
begin
  Self.SetValues(Json);
end;

procedure TZrValueModel.SetBemerkung(const Value: string);
begin
  FBemerkung := Value;
end;

procedure TZrValueModel.SetBS1(const Value: string);
begin
  FBS1 := Value;
end;

procedure TZrValueModel.SetBS2(const Value: string);
begin
  FBS2 := Value;
end;

procedure TZrValueModel.SetDatum(const Value: TDateTime);
begin
  FDatum := Value;
end;

procedure TZrValueModel.SetId(const Value: Integer);
begin
  FId := Value;
end;

procedure TZrValueModel.SetKst(const Value: string);
begin
  FKst := Value;
end;

procedure TZrValueModel.SetValue(const Value: string);
begin
  FValue := Value;
end;

procedure TZrValueModel.SetValues(Obj: TJsObject);
begin
  Self.ClearValues;
  if Obj['Id'] <> nil then
    Self.Id := StrToInt(string(Obj['Id']));
  if Obj['Datum'] <> nil then
    Self.Datum := StrToDateTime(string(Obj['Datum']));
  if Obj['Zeitart'] <> nil then
    Self.Zeitart := string(Obj['Zeitart']);
  if Obj['BS1'] <> nil then
    Self.BS1 := string(Obj['BS1']);
  if Obj['Zeitpunkt1'] <> nil then
    Self.Zeitpunkt1 := StrToDateTime(string(Obj['Zeitpunkt1']));
  if Obj['BS2'] <> nil then
    Self.BS2 := string(Obj['BS2']);
  if Obj['Zeitpunkt2'] <> nil then
    Self.Zeitpunkt2 := StrToDateTime(string(Obj['Zeitpunkt2']));
  if Obj['Value'] <> nil then
    Self.Value := string(Obj['Value']);
  if Obj['Kst'] <> nil then
    Self.Kst := string(Obj['Kst']);
  if Obj['Bemerkung'] <> nil then
    Self.Bemerkung := string(Obj['Bemerkung']);
end;

procedure TZrValueModel.SetValues(Json: string);
var
  Obj: TJsObject;
begin
  Obj := TJsJson.parseObject(Json);
  Self.SetValues(Obj);
end;

procedure TZrValueModel.SetZeitart(const Value: string);
begin
  FZeitart := Value;
end;

procedure TZrValueModel.SetZeitpunkt1(const Value: TDateTime);
begin
  FZeitpunkt1 := Value;
end;

procedure TZrValueModel.SetZeitpunkt2(const Value: TDateTime);
begin
  FZeitpunkt2 := Value;
end;

function TZrValueModel.ToString: string;
begin
  Result := '    ' + Self.Zeitart + ' ' + Self.BS1 + ' ' +
    DateTimeToStr(Self.Zeitpunkt1) + ' ' + Self.BS2 + ' ' +
    DateTimeToStr(Self.Zeitpunkt2) + ' ' + Self.Value;
end;

end.
